import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Table.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import { FaFileExport } from "react-icons/fa";
import { Audit, FunctionEnum } from "../interFaces/interfaces";
import EncryptionUtils from "../main/encryptionUtils";
const FunctionNCTracker: React.FC = () => {
  const [data, setData] = useState<Audit[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [fields, setFields] = useState<Record<string, any>>({});
  const [functionEnums, setFunctionEnums] = useState<FunctionEnum[]>([]);
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");
  const columns = [{ key: "campaignName", label: "Campaign Name" }, { key: "functionName", label: "Function Name" }, { key: "auditStatus", label: "Audit Status" }]
  const exportFieldLabels: Record<string, string> = { questionText: "Question Text", typeOfFindings: "Type of Findings", findings: "Findings", correctiveAction: "Corrective Action", correction: "Correction", ncTrackerStatus: "NC Tracker Status", rca: "RCA", actionTaken: "Action Taken", evidenceRequired: "Evidence Required", isoClauseReference: "ISO Clause Reference", annexAControlReference: "Annex A Control Reference" };
  const exportFields = Object.keys(exportFieldLabels);
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["functionNcTracker"]) {
      setFields(permissions.tabs["functionNcTracker"].fields);
    } else {
      console.log("No permissions found for 'functionNcTracker' tab");
    }
  }, []);
  useEffect(() => {
    const fetchFunctionEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/FunctionEnum");
        setFunctionEnums(response || []);
      } catch (error) {
        console.error("Error fetching function enums:", error);
      }
    };
    fetchFunctionEnums();
  }, []);
  useEffect(() => {
    const fetchAudits = async () => {
      setLoading(true);
      try {
        const response = await apiCall("get", `/api/function/audit?clientId=${clientId}&page=${currentPage - 1}&size=${itemsPerPage}`);
        setData(response.content || []);
        setTotalPages(response.totalPages || 0);
        setTotalElements(response.totalElements || 0);
      } catch (error) {
        console.error("Error fetching audits:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAudits();
  }, [clientId, currentPage, itemsPerPage]);
  const safe = (value: any) => {
    return value !== null && value !== undefined && value !== "" ? value : "N/A";
  };
  const fetchAllAudits = async (): Promise<Audit[]> => {
    try {
      const response = await apiCall("get", `/api/function/audit?page=0&size=${totalElements}&clientId=${clientId}`);
      const audits = response.content || [];
      const mapped = audits.map((a: Audit) => ({
        ...a, auditId: safe(a.auditId), campaignId: safe(a.campaignId), campaignName: safe(a.campaignName), functionId: safe(a.functionId), functionName: a.functionName ? getFunctionDescription(a.functionName) : "N/A", auditStatus: safe(a.auditStatus),
      }));
      return mapped;
    } catch (error) {
      console.error("Failed to export audits. Please try again later.");
      return [];
    }
  };
  const handleRowExport = async (audit: Audit) => {
    try {
      const { auditId, campaignId, functionId } = audit;
      const response = await apiCall("get", `/api/function/nctracker/campaign/${campaignId}/function/${functionId}/audit/${auditId}/questions`, {}, { page: 0, size: 2147483647 });
      const questions = response.content || [];
      if (questions.length === 0) {
        console.warn("No data available for export");
        return;
      }
      const selectedData = questions.map((q: Record<string, any>) => {
        const filtered: Record<string, any> = {};
        exportFields.forEach((field) => {
          filtered[field] = q[field] || "";
        });
        return filtered;
      });
      const headers = exportFields.map((f) => exportFieldLabels[f]).join(",");
      const rows = selectedData
        .map((obj: any) =>
          exportFields.map((field) => `"${String(obj[field]).replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");
      const csvContent = headers + "\n" + rows;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Function NC Tracker_${auditId}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Failed to export audit:", err);
    }
  };
  const getFunctionDescription = (value: string) => {
    const enumItem = functionEnums.find(item => item.value === value);
    return enumItem ? enumItem.description : value || "N/A";
  };
  const handleAuditClick = (audit: Audit) => {
    navigate(`/functionnctrackerdetails/${audit.campaignName}`, {
      state: { auditId: audit.auditId, campaignId: audit.campaignId, functionId: audit.functionId }
    });
  };
  const handleAuditCellClick = (audit: Audit) => {
    if (!fields.view) return;
    handleAuditClick(audit);
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Function NC Tracker</h2>
        <div className="table-title-actions">
          <ExportButton data={data} columns={columns} fetchAllData={fetchAllAudits} fileName="function_audits" />
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((audit) => (
                  <tr key={audit.auditId}>
                    <td onClick={() => handleAuditCellClick(audit)} className={fields.view ? "clickable" : ""}> {audit.campaignName}</td>
                    <td>{getFunctionDescription(audit.functionName || "N/A")}</td>
                    <td>{audit.auditStatus || "N/A"}</td>
                    <td className="action-cell">
                      <FaFileExport className="action-button" onClick={() => handleRowExport(audit)} title="Export this Function Audit" />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length + 1} className="no-data">No audits found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
    </div>
  );
};
export default FunctionNCTracker;